module.exports = __webpack_public_path__ + "static/media/bahavioural_manager.040690cc.svg";